import { ApiPutImagePrompt } from "@/apis/prompt";
import { defineStore } from "pinia";
import {
  CAMERA_CATE_ID,
  CHARACTER_CATE_ID,
  CLOTHING_CATE_ID,
  ENV_CATE_ID,
  FACE_EXPRESSION_CATE_ID,
  ImagePromptItem,
  POSE_CATE_ID,
} from "./prompts";
import { showLoadingToast, showSuccessToast } from "vant";
import { StorageGet } from "@/tools/localStorage";
import i18n from "@/locales";
import { sessionStorageGet } from "@/tools/sessionStorage";

export const usePromptManager = defineStore("PromptManager", {
  state: () => ({
    FirstType: [
      CHARACTER_CATE_ID,
      ENV_CATE_ID,
      FACE_EXPRESSION_CATE_ID,
      POSE_CATE_ID,
      CLOTHING_CATE_ID,
      CAMERA_CATE_ID,
    ],
    showEdit: false,
    allDom: null as any,
    editCache: {
      parentId: 0,
      id: 0,
      displayText: "",
      text: "",
      children: [] as any,
    },
    activeEditObj: {} as any,
  }),
  actions: {
    async confirmEdit() {
      if (this.activeEditObj.id) {
        this.activeEditObj.displayText = this.editCache.displayText;
        this.activeEditObj.text = this.editCache.text;
      } else {
        this.activeEditObj.push(this.editCache);
      }
      this.showEdit = false;
    },
    async update(list: any, isReset?: boolean) {
      let { id, zh, en } = sessionStorageGet("imgPrompts");

      const isCN = i18n.global.locale.value === "zh-CN";

      let toast = showLoadingToast({
        message: i18n.global.t("Message.updating"),
        mask: true,
        duration: 0,
      });

      if (!isReset) {
        function addSort(list: any[]) {
          list.forEach((item, idx) => {
            item.sort = idx;
            if (item.children) addSort(item.children);
          });
        }
        addSort(list);
        const recordMap = new Map();
        function dfs(item: ImagePromptItem) {
          if (!recordMap.has(item.id))
            recordMap.set(item.id, {
              id: item.id,
              parentId: item.parentId,
              displayText: item.displayText,
              text: item.text,
            });
          item.children.forEach((v) => dfs(v));
        }
        list.forEach((v: ImagePromptItem) => dfs(v));
        if (isCN) zh = JSON.stringify([...recordMap.values()]);
        else en = JSON.stringify([...recordMap.values()]);
      } else {
        if (isCN) zh = "";
        else en = "";
      }

      try {
        if (!en) en = "";
        if (!zh) zh = "";
        if (typeof zh === "object") zh = JSON.stringify(zh);
        if (typeof en === "object") en = JSON.stringify(en);
        await ApiPutImagePrompt({ zh, id, en });
        toast = showSuccessToast({
          message: i18n.global.t("Message.updatedSuccessfully"),
          duration: 0,
          mask: true,
        });
        location.reload();
      } catch (e) {
        toast.close();
      }
    },
  },
});
